import React from 'react';
import { render } from 'react-dom';
import App from './components/app/App';

render(
  <App />,
  document.getElementById('root')
);
